import Request from '../../common/api/request';
import ServiceResultFactory from '../../common/api/ServiceResultFactory';
import { Platform } from '../../common/Constants';

const createVideoEntry = (baseUrl, locale, orgId, eventEditionId, videoS3Key) =>
  new Promise((resolve, reject) => {
    const mutation =
      `mutation 
    {
      createVideoEntry(
        orgId: "${orgId}"
        eventEditionId: "${eventEditionId}"
        videoS3Key: "${videoS3Key}"
        videoType: "Product"
        platform: "${Platform.vidyard}"
       ) 
       {
          videoId
       }
    }`;

    Request.graphqlRequest(`${baseUrl}/graphql`, mutation)
      .then((response) => {
        resolve(response.body.data.createVideoEntry.videoId);
      })
      .catch((result) => {
        reject(ServiceResultFactory.fromError(locale, result, false));
      });
  });

const getVideoStatus = (baseUrl, videoId) => {
  const commonVideoQuery = `query{
    video(
        videoId: "${videoId}"
  ) {
    fileName,publishStatus,ingestionStatus,ingestionErrorMessage,streamingReferenceId
  }
  }`;
  return Request.graphqlRequest(`${baseUrl}/graphql`, commonVideoQuery)
    .then(response => response.body.data.video)
    .catch(result =>
      ServiceResultFactory.fromError(result, false));
};


export default {
  createVideoEntry, getVideoStatus
};
